<template>
  <div class="search-filter-summary-loading d-block d-sm-none">
    <div class="search-filter-summary-loading-search-presets">
      <div class="search-filter-summary-loading-search-preset" />
      <div class="search-filter-summary-loading-search-preset" />
      <div class="search-filter-summary-loading-search-preset-btn" />
    </div>
  </div>
</template>

<script>
/*

@@author        j0Shi
@@date          2019.11.14
@@desc          ObjectSearchList placeholder that shows when object page loads
@@usedby        Search -> SearchObjectList

*/
export default {

};
</script>

<style lang="scss" scoped>
.search-filter-summary-loading-search-presets {
  overflow: hidden;
  margin: $margin_content_xs 0 0;
  padding: 0 15px;

  .search-filter-summary-loading-search-preset {
    width: 51%;
    float: left;
    height: $placeholder-text-height;
    margin: $placeholder-text-margin;
    background-color: $placeholder-color1;
  }

  .search-filter-summary-loading-search-preset-btn {
    float: right;
    width: 20%;
    height: $placeholder-text-height;
    margin: $placeholder-text-margin;
    background-color: $placeholder-color1;
  }
}
</style>
